import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { AUTOMATION_TESTING_CONST } from '../automation-test-constants';
import { BxLogger } from '../bx-logger.service';
import { DialogParams, DialogService } from '../dialog.service';
import { TenantService } from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class TermsConditionsService {
    constructor(
        private dialogService: DialogService,
        private sharedData: SharedDataService,
        private tenantService: TenantService,
        private logger: BxLogger,
        private translateService: TranslateService
    ) {}

    public async verifyTermsAndConditionsAccepted() {
        if (localStorage.getItem('impersonate_uid')) {
            return;
        }
        if (this.sharedData.UserData.tenant.ID_Reseller?.toUpperCase() === AUTOMATION_TESTING_CONST.resellerId) {
            return;
        }

        const data = await this.tenantService.getTermsAndConditionsAccepted();
        if (!data?.accepted) {
            this.showDialog();
        }
    }

    private showDialog() {
        const dialogParams: DialogParams = {
            title: 'Terms and conditions update',
            input: 'checkbox',
            inputPlaceholder: `I accept the Buildxact <a class="btn-bx-hyperlink btn-bx-hyperlink-dialog" href="${this.translateService.instant(
                'terms-conditions.url'
            )}" target="_blank">Terms and Conditions</a>.`,
            type: 'success',
            showCancel: false,
            okText: 'Proceed',
            allowHtml: true,
            text: `We have recently updated our Terms and Conditions. Please read and accept it below to continue.`,
            dismissable: false,
            customClass: { popup: 'bx-dialog bx-dialog-success', input: 'form-v2' },
            inputValidator: (value: string) => {
                if (!value) {
                    return 'Please accept terms and conditions';
                } else return null;
            },
        };
        this.dialogService.show(dialogParams).then(
            () => {
                this.captureAcceptance();
            },
            (rejected) => {
                this.showDialog();
            }
        );
    }

    private captureAcceptance() {
        this.tenantService
            .setTermsAndCondtionsAccepted()
            .then(() => {
                this.logger.success('Terms and Conditions accepted.');
            })
            .catch(() => {
                this.logger.error('An error occured. Please try again.');
            });
    }
}
